import { render, staticRenderFns } from "./TabPresentations.vue?vue&type=template&id=17276482"
import script from "./TabPresentations.vue?vue&type=script&lang=js"
export * from "./TabPresentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports